import { configureStore } from "@reduxjs/toolkit";

import authSlice from "@/auth/authSlice";
import userPermissionsSlice from "@/auth/permissionsSlice";
import attendanceSlice from "@/features/academics/attendance/attendanceSlice";
import classesSlice from "@/features/academics/classes/classesSlice";
import studentSlice from "@/features/academics/students/studentSlice";
import brandKitSlice from "@/features/branding/brandKitSlice";
import paymentSlice from "@/features/feesFinance/payments/paymentSlice";
import hostTenantSlice from "@/features/hostTenant/hostTenantSlice";
import teacherSlice from "@/features/humanResources/teachers/teacherSlice";
import librarySlice from "@/features/infrastructure/library/librarySlice";
import platformSessionSlice from "@/features/platformOwner/platformSessionSlice";
import tenantBrandingSlice from "@/features/tenantBranding/tenantBrandingSlice";
import permissionsSlice from "@/features/userAccess/permissions/permissionsSlice";
import userSlice from "@/features/userAccess/users/userSlice";
import notificationSlice from "@/screens/notifications/notificationSlice";
import themeSlice from "@/theme/themeSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    theme: themeSlice,
    notifications: notificationSlice,
    users: userSlice,
    students: studentSlice,
    teachers: teacherSlice,
    attendance: attendanceSlice,
    library: librarySlice,
    payments: paymentSlice,
    classes: classesSlice,
    permission: permissionsSlice,
    userPermissions: userPermissionsSlice,
    tenantBranding: tenantBrandingSlice,
    brandKit: brandKitSlice,
    hostTenant: hostTenantSlice,
    platformSession: platformSessionSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
